/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useRef, useState } from 'react';
import BreadCrumb from '../../components/BreadCrumb';
import { BiCalendar } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Wrapper,
  Container2,
  TitleWrapper,
  Title,
  SubWrapper,
  Subtitle,
  DetailContent,
  PixArea,
  IconContainer,
  QrCode,
  Code,
  Button,
  PaymentCard,
  IconDownload,
  PaymentResult,
} from './styles';
import api from '../../services/api';
import formatPrice from '../../services/utils/formatPrice';
import ClipLoader from 'react-spinners/ClipLoader';
import QRCode from 'react-qr-code';
import Toast from '../../components/Toast';
import { toast } from 'react-toastify';
import { useIframePayment } from '../../contexts/IframePaymentContext';
import { navigationUrl } from '../../store/analytic/actions';
import { ReactComponent as AlertIcon } from '../../assets/icons/alert.svg';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-circle.svg';

type DealProps = {
  contractDebt: GQL.IDebt;
  proposal: GQL.IOption;
  dealId: number;
  detail: {
    portion: string;
    value: string;
    date: string;
  };
  dealState: GQL.IState;
};

export const getMessageByPaymentStatus = (iframePaymentStatus: GQL.PaymentFrameParsed | null) => {
  if (iframePaymentStatus?.status === 'CONFIRMED') {
    return (
      <PaymentResult>
        <CheckIcon style={{ width: 20, height: 20, color: 'green' }} />
        <p style={{ color: 'black', textAlign: 'center', fontSize: '16px' }}>Pagemento efetuado com sucesso. A baixa será realizada em até 24h.</p>
      </PaymentResult>
    );
  }

  if (iframePaymentStatus?.status === 'DENIED') {
    return (
      <PaymentResult>
        <AlertIcon style={{ width: 40, height: 40 }} />
        <p style={{ color: 'black', textAlign: 'center', fontSize: '16px' }}>Pagamento Negado</p>
      </PaymentResult>
    );
  }

  if (iframePaymentStatus?.status === 'PAYMENT_ERROR') {
    return (
      <PaymentResult>
        <AlertIcon style={{ width: 40, height: 40 }} />
        <p style={{ color: 'black', textAlign: 'center', fontSize: '16px' }}>{iframePaymentStatus?.details ?? 'Pagamento com erro'}</p>
      </PaymentResult>
    );
  }

  return null;
}

const FinishedDeal = () => {
  const history = useHistory();
  const location = useLocation<DealProps>();
  const deal = location.state;
  const [pixData, setPixData] = useState<GQL.IGetPixDataPublicResponse>();
  const [billetData, setBilletData] = useState<GQL.IBillet>();
  const [loading, setLoading] = useState(false);
  const [iframePayment, setIframePayment] = useState<string | null>(null);
  const [requestIframe, setRequestIframe] = useState(false);
  const downloadLink = useRef<HTMLAnchorElement>(null);
  const dispatch = useDispatch();
  const { iframePaymentStatus, clearIframePaymentStatus } = useIframePayment();

  useEffect(() => {
    clearIframePaymentStatus();
  }, [])

  useEffect(() => {
    async function fetchIframePayment() {
      try {
        setLoading(true);
        const res = await api.getIframePayment({
          dealId: deal.dealId,
          portionId: 1,
          databaseId: deal.contractDebt.databaseId,
        });
        setIframePayment(res.link);
      } catch (error) {
        console.error(`Erro ao buscar iframe de pagamento: ${error}`);
      } finally {
        setLoading(false);
      }
    }

    if (requestIframe) {
      fetchIframePayment();
    }

  }, [deal.contractDebt.databaseId, deal.contractDebt.portion, deal.dealId, requestIframe])

  useEffect(() => {
    const handleSendIframeLog = async () => {
      if (!iframePaymentStatus) return;

      await api.sendIframeLog({
        databaseId: deal.contractDebt.databaseId,
        responseCode: iframePaymentStatus.responseCode,
        status: iframePaymentStatus.status,
        details: iframePaymentStatus.details,
        auxiliary: iframePaymentStatus.auxiliary,
        agreementId: String(deal.dealId),
        finContract: deal.contractDebt?.contractDetails?.[0]?.contract ?? "",
      });

      if (!getMessageByPaymentStatus(iframePaymentStatus)) {
        history.replace('/erro');
      }
    }

    handleSendIframeLog();
  }, [clearIframePaymentStatus, deal.contractDebt, deal.dealId, history, iframePaymentStatus])

  const { selectedPaymentMethod } = useSelector((state: ApplicationState) => ({
    selectedPaymentMethod: state.contract.selectedPaymentMethod,
  }));

  const downloadBillet = (base64: string) => {
    downloadLink.current!.target = '_self';
    downloadLink.current!.href = `data:application/pdf;base64,${base64}`;
    downloadLink.current!.click();
  };

  const copyToClipboard = (text: string) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    toast.error(
      <Toast
        title={'Aviso'}
        type={'success'}
        description={'Copiado para Área de Transferência'}
      />
    );
  };

  const base64ToBlob = (base64: string, type = 'application/octet-stream') => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  useEffect(() => {
    async function fetchPixData() {
      try {
        setLoading(true);
        const res = await api.getPixData({
          options: { dealId: deal.dealId, portionId: 1 },
          databaseId: deal.contractDebt.databaseId,
        });
        setPixData(res);
      } catch (error) {
        console.error(`Erro ao buscar dados Pix: ${error}`);
      } finally {
        setLoading(false);
      }
    }

    async function fetchBilletData() {
      try {
        const res = await api.getBilletDeal({
          dealId: deal.dealId,
          portionId: 1,
          databaseId: deal.contractDebt.databaseId,
        });
        setBilletData(res);
        const blob = base64ToBlob(res.linhaDigitavel, 'application/pdf');
        const url = URL.createObjectURL(blob);
        const pdfWindow = window.open('');
        pdfWindow!.document.write(
          "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
        );
      } catch (error) {
        console.error(`Erro ao buscar boleto: ${error}`);
      }
    }

    if (selectedPaymentMethod === 1) fetchPixData();
    if (selectedPaymentMethod === 0) fetchBilletData();
  }, [deal, selectedPaymentMethod]);

  useEffect(() => {
    window.onpopstate = () => {
      history.replace('/acordos-debitos');
    };
  }, [history]);

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/efetuouPromessa ',
      })
    );
  }, [dispatch]);

  return (
    <Wrapper>
      <Container2>
        <TitleWrapper>
          <Title>Acordo Confirmado</Title>
          <BreadCrumb
            currentPage='Acordo'
            previouPages={[{ name: 'Débitos e Acordos', route: '/contrato' }]}
            onNavigateBackTo={() => {
              history.replace('/contrato');
            }}
            showBreadCrumbOnMinWidth='960px'
          />
        </TitleWrapper>
        <SubWrapper>
          <Subtitle>Confira as informações do acordo:</Subtitle>
          <DetailContent style={{ width: '100%' }}>
            <div className='default'>
              <strong className='space-right'>Valor do acordo:</strong>
              <strong>
                R${' '}
                {deal.dealState.agreementValue
                  ? formatPrice(deal.dealState.agreementValue)
                  : '--,--'}
              </strong>
            </div>
            <div className='default'>
              <BiCalendar className='space-right' />
              Vencimento:{' '}
              <span>
                <strong>{deal.detail.date}</strong>
              </span>
            </div>
          </DetailContent>
          {/* PIX */}
          {selectedPaymentMethod === 1 && (
            <PixArea>
              {loading ? (
                <IconContainer>
                  <ClipLoader color='#222' loading={loading} size={50} />
                </IconContainer>
              ) : (
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <QrCode>
                    <QRCode
                      size={200}
                      value={pixData?.linhaDigitavel?.toString() ?? ''}
                    />
                  </QrCode>
                  <Code
                    onClick={() =>
                      copyToClipboard(pixData?.linhaDigitavel?.toString() ?? '')
                    }
                  >
                    {pixData?.linhaDigitavel
                      ? `${pixData?.linhaDigitavel.substring(0, 40)}...`
                      : ''}
                  </Code>
                  <Button
                    color='primary'
                    onClick={() =>
                      copyToClipboard(pixData?.linhaDigitavel?.toString() ?? '')
                    }
                  >
                    Copiar
                  </Button>
                </div>
              )}
            </PixArea>
          )}
          {/* Boleto */}
          {selectedPaymentMethod === 0 && (
            <>
              <a
                style={{ display: 'none' }}
                ref={downloadLink}
                download={'boleto.pdf'}
              />
              <PaymentCard
                onClick={() =>
                  downloadBillet(billetData?.linhaDigitavel as string)
                }
              >
                <span className='icon'>
                  <IconDownload />
                </span>
                <p className='text'>Download do Boleto - PDF</p>
                <span />
              </PaymentCard>
            </>
          )}

          {
            iframePayment && !iframePaymentStatus && (
              <iframe
                src={iframePayment}
                title='Iframe de Pagamento'
                width='100%'
                height='600px'
                style={{ border: 'none', borderRadius: '8px', marginTop: '10px' }}
                allow="payment"
              />
            )
          }

          {iframePaymentStatus?.status === 'CONFIRMED' && (
            <p style={{ color: 'green' }}>Pagamento Confirmado</p>
          )}

          {iframePaymentStatus?.status === 'DENIED' && (
            <p style={{ color: 'red' }}>Pagamento Recusado</p>
          )}

          {!iframePayment && (
            <Button
              color='primary'
              onClick={() => setRequestIframe(true)}
              disabled={loading}
            >
              <p style={{ fontSize: '16px', fontWeight: 'bold' }}>{loading ? 'Aguarde...' : 'Efetuar Pagamento'}</p>
            </Button>
          )}

          {
            iframePaymentStatus?.status &&
            getMessageByPaymentStatus(iframePaymentStatus)
            && (
              <div style={{ marginTop: '15px', width: '100%' }}>
                {getMessageByPaymentStatus(iframePaymentStatus)}
              </div>
            )
          }
        </SubWrapper>
      </Container2>
    </Wrapper>
  );
};

export default FinishedDeal;
